import React from "react"
import {
  TransitionGroup,
  Transition as ReactTransition,
} from "react-transition-group"

import styled from "styled-components"

const First = styled.div`
position: absolute;
left: -50%;
top: -10%;
width: 250vw;
height: 200vh;
z-index: 1000;
transform: translateY(-250vh) rotateZ(-30deg);
background: ${props=>props.theme.color.primary};
transform-origin: center center;
`

export const Transition = ({ location, children }) => {
  const timeout = 600
  const getTransitionStyles = {
    entering: {
      position: "fixed",
      transform: `translateY(150vh) rotateZ(0)`,
    },
    entered: {
      transition: `transform ${timeout/2}ms ease-in-out`,
        transform: `translateY(-350vh) rotateZ(40deg)`,
    },
    exiting: {
      transition: `transform ${timeout}ms ease-in-out`,
      transform: `translateY(150vh) rotateZ(0)`,
    },
  }
  const getOpacityStyles = {
    entering: {
        position: "fixed",
        opacity: 0,
    },
      entered: {
          transition: `opacity ${timeout}ms ease-in-out`,
          opacity: 1,
      },
      exiting: {
        transition: `opacity ${timeout}ms ease-in-out`,
        opacity: 0,
      },      
  }
  return (
    <TransitionGroup>
      <ReactTransition
        key={location.pathname}
        timeout={{
          enter: timeout,
          exit: timeout,
        }}
      >
        {status => (
            <>
            <First style={{...getTransitionStyles[status]}}></First>
          <div style={{...getOpacityStyles[status]}}>{children}</div>
          </>
        )}
      </ReactTransition>
    </TransitionGroup>
  )
}
